export default {"src":"/_next/static/media/player_placeholder.45be18d9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};